
import { 
  Car, 
  Route, 
  MapPin, 
  UserPlus
} from "lucide-react";
import type { MenuItem } from "../types";

export const transportationSection: MenuItem = {
  title: "المواصلات",
  href: "#",
  icon: Car,
  color: "from-green-500 to-green-600",
  subItems: [
    {
      title: "أنواع السيارات",
      href: "/vehicle-types",
      icon: Car,
      color: "from-green-500 to-green-600",
    },
    {
      title: "ربط السيارات بالدولة",
      href: "/country-vehicle-mapping",
      icon: Route,
      color: "from-emerald-500 to-emerald-600",
    },
    {
      title: "الاستقبال والتوديع",
      href: "/airport-transfers",
      icon: MapPin,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "الجولات السياحية",
      href: "/tourist-tours",
      icon: Route,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: "حساب مواصلات الشمال التركي",
      href: "/turkish-north-transport",
      icon: Car,
      color: "from-red-500 to-red-600",
    },
    {
      title: "أسماء السائقين",
      href: "/drivers",
      icon: UserPlus,
      color: "from-orange-500 to-orange-600",
    }
  ]
};
